if ( typeof ProductPage !== 'function' ) {
	
	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('.product-gallery');

			// qty helper

			if ( this.querySelector('.product__quantity') ) {
				this.querySelector('.product__quantity').addEventListener('click', e=>{
					e.target.select();
				});
			}

			// Product variant event listener for theme specific logic

			const productVariants = this.querySelector('product-variants');
			if ( productVariants ) {
				productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:productVariants});
			}

			// Look at add to cart button for changes

			if ( this.querySelector('.product__add-to-cart') ) {
				const addToCartHolder = this.querySelector('.product__cart-actions-holder');
				new MutationObserver((mutationsList, observer)=>{
					for ( const mutation of mutationsList ) {
						if ( mutation.attributeName == 'class' ) {
							addToCartHolder.classList.remove('disabled');
							addToCartHolder.classList.remove('working');
							if ( mutation.target.classList.contains('disabled') ) {
								addToCartHolder.classList.add('disabled');
							}
							if ( mutation.target.classList.contains('working') ) {
								addToCartHolder.classList.add('working');
							}
						}
					} 
				}).observe(this.querySelector('.product__add-to-cart'), {
					attributes: true, childList: false, subtree: false
				});
				if ( this.querySelector('.product__add-to-cart').classList.contains('disabled') ) {
					addToCartHolder.classList.add('disabled');
				}
			}

			// Helper events for different media (legacy slider only)

			if ( this.productGallery ) {
				this.productGallery.addEventListener('change', e=>{
					if ( this.productGallery.items[this.productGallery.index].dataset.productMediaType == 'model' ) {
						setTimeout(()=>{
							this.productGallery.toggleDragging(false);
						}, 15);
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.items[this.productGallery.index].dataset.mediaId);
						}
					}
					this._pauseAllMedia();
				});
			}

			// Calculate complete product height (add extra sections)

			if ( ! this.classList.contains('featured-product') ) {

				const productOffers = this.querySelector('.product__offers > div');
				this._EVENT_SCROLL = e=>{
					if ( window.innerHeight < productOffers.offsetHeight ){
						let y = this.getBoundingClientRect().y,
								z = productOffers.offsetHeight - window.innerHeight;
						if ( Math.abs(y) < z ) {
							productOffers.style.top = `${y}px`;
						} else if ( Math.abs(y) >= z ) {
							productOffers.style.top = `${-z}px`;
						}
					}
				};
				window.addEventListener('scroll', this._EVENT_SCROLL, {passive:true});

				this.style.minHeight = `${productOffers.offsetHeight}px`;
				setInterval(()=>{
					this.style.minHeight = `${productOffers.offsetHeight}px`;
				}, 500);

			}

			// Add to cart event

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				if ( this.querySelector('.product__add-to-cart') ) {
					this.querySelector('.product__add-to-cart').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}

				if ( this.querySelector('.product__form') ) {
					this.querySelector('.product__form').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar .close-sidebar').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

		}

		onVariantChangeHandler(e){

			const picker = e.target;

			// Which media to promote? Prefer the fully-selected variant's featured
			// media. If only the colour is picked (no size yet), fall back to the
			// featured media of the first variant matching that colour, so the photo
			// switches on colour selection alone.

			let media = picker.currentVariant ? picker.currentVariant.featured_media : null;

			if ( media == null ) {
				const colorInput = picker.querySelector('.product-variant__item--color .product-variant__input:checked');
				if ( colorInput && typeof picker.getVariantData === 'function' ) {
					const match = picker.getVariantData().find(v=>{
						return v.featured_media != null && v.options && v.options.indexOf(colorInput.value) !== -1;
					});
					if ( match ) media = match.featured_media;
				}
			}

			if ( media == null ) return;

			// Bring that media to the front of the redesign gallery: reorder to the
			// top on desktop (CSS-scoped), scroll to the matching slide on mobile.

			const gallery = this.querySelector('.product__gallery-redesign');
			if ( ! gallery ) return;

			const mediaItem = gallery.querySelector('.product-gallery__item[data-media-id="' + media.id + '"]');
			const galleryImage = mediaItem ? mediaItem.closest('.product__gallery-image') : null;
			if ( ! galleryImage ) return;

			gallery.querySelectorAll('.product__gallery-image.is-variant-active').forEach(el=>{
				if ( el !== galleryImage ) el.classList.remove('is-variant-active');
			});
			galleryImage.classList.add('is-variant-active');

			if ( window.matchMedia('(max-width: 834px)').matches ) {
				gallery.scrollTo({ left: galleryImage.offsetLeft, behavior: 'smooth' });
			}

		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}

	}
	
	if (typeof customElements.get("product-page") == "undefined") {
		customElements.define("product-page", ProductPage);
	}
	
}